import createReactClass from 'create-react-class';
import _ from 'lodash';
import React from 'react';
import GeometryMixin from '../../../../mixins/geometry-mixin';

export default createReactClass({
  displayName: 'Points',
  mixins: [GeometryMixin],

  getDefaultProps() {
    return {
      value: [],
      colour: 'black',
      strokeColour: 'black',
      strokeWidth: 1,
      skipZeroDots: true,
      scale: { x: 0, y: 0 },
      radius: 5,
      hoverWidth: 2,
      isFaded: false,
      isHovered: false
    };
  },

  render() {
    let toY;
    let values = this.props.value;
    if (this.props.skipZeroDots) {
      values = this.props.value.filter((v) => v.y !== 0);
    }

    let { radius } = this.props;
    if (this.props.isHovered) {
      radius = this.props.radius * this.props.hoverWidth;
    }

    // opacity = if @props.isFaded then 0.3 else 1.0
    const numbers = values.map((v, i) => {
      if (!this.props.pointValues || v.x === 0) {
        return;
      } // hide first value as it's on the axis
      toY = this.toY(v.y, this.props.scale, -3);
      if (toY.startsWith('-')) {
        toY = this.toY(v.y, this.props.scale, 10);
      }
      return (
        <text key={i + 't'} x={this.toX(v.x)} y={toY} textAnchor="middle" fill={this.props.colour}>
          {this.props.hasValues ? v.value : null}
        </text>
      );
    });

    const points = values.map((v, i) => {
      return (
        <circle
          key={i}
          r={radius}
          cx={this.toX(v.x)}
          cy={this.toY(v.y)}
          fill={this.props.colour}
          stroke={this.props.strokeColour}
          strokeWidth={this.props.strokeWidth}
        />
      );
    });

    return (
      <g>
        {points}
        {numbers}
      </g>
    );
  }
});
